export type EventTagId =
  | 'now' | 'tonight' | 'parties' | 'social' | 'nearby' | 'high-energy'
  | 'food' | 'activities' | 'chill' | 'date-idea' | 'solo-friendly' | 'student' | 'free';

// Smart filters are computed dynamically — not stored as event tags.
export const SMART_FILTER_IDS = new Set<EventTagId>(['now', 'nearby', 'tonight']);

// UploadTagId excludes smart filters — only real content tags that users assign to events.
export type UploadTagId = Exclude<EventTagId, 'now' | 'nearby' | 'tonight'>;

// FeedChipId covers all 12 chips including smart ones.
export type FeedChipId = EventTagId;

export const EVENT_TAGS: Array<{ id: EventTagId; label: string; icon: string }> = [
  { id: 'now',           label: 'Now',          icon: 'clock'    },
  { id: 'tonight',       label: 'Tonight',      icon: 'moon'     },
  { id: 'parties',       label: 'Parties',      icon: 'zap'      },
  { id: 'social',        label: 'Social',       icon: 'users'    },
  { id: 'nearby',        label: 'Nearby',       icon: 'map-pin'  },
  { id: 'high-energy',   label: 'High Energy',  icon: 'activity' },
  { id: 'food',          label: 'Food',         icon: 'coffee'   },
  { id: 'activities',    label: 'Activities',   icon: 'compass'  },
  { id: 'chill',         label: 'Chill',        icon: 'sun'      },
  { id: 'date-idea',     label: 'Date Idea',    icon: 'heart'    },
  { id: 'solo-friendly', label: 'Solo Friendly', icon: 'user'   },
  { id: 'student',       label: 'Student',      icon: 'book-open' },
  { id: 'free',          label: 'Free',         icon: 'tag'      },
];

export const SMART_FILTERS = EVENT_TAGS.filter(t => SMART_FILTER_IDS.has(t.id));
export const UPLOAD_TAGS = EVENT_TAGS.filter(t => !SMART_FILTER_IDS.has(t.id)) as Array<{ id: UploadTagId; label: string; icon: string }>;

// Feed chips show smart filters plus real upload tags.
export const FEED_TAGS = [...SMART_FILTERS, ...UPLOAD_TAGS];
export const FEED_CHIPS = FEED_TAGS;

// Used to filter stored tags back into typed sets on load.
export const VALID_EVENT_TAG_IDS = new Set<string>(EVENT_TAGS.map(t => t.id));
export const VALID_UPLOAD_TAG_IDS = new Set<string>(UPLOAD_TAGS.map(t => t.id));

const TAG_TO_CATEGORY: Partial<Record<EventTagId, string>> = {
  parties:         'nightlife',
  'high-energy':   'nightlife',
  social:          'social',
  food:            'food',
  activities:      'adventure',
  chill:           'culture',
  'date-idea':     'culture',
  'solo-friendly': 'social',
  student:         'social',
};

export function deriveCategoryFromTags(selectedTags: UploadTagId[]): string {
  for (const tag of selectedTags) {
    const cat = TAG_TO_CATEGORY[tag];
    if (cat) return cat;
  }
  return 'social';
}
